import axios from 'axios'; // ตรวจสอบว่ามีการ import axios แค่บรรทัดนี้บรรทัดเดียว
import moment from 'moment-timezone';



const PERSONAL_ACCESS_TOKEN = process.env.REACT_APP_PERSONAL_ACCESS_TOKEN; // ใส่ Personal Access Token ที่คุณสร้างไว้
const BASE_ID = process.env.REACT_APP_BASE_ID; // ใส่ Base ID ของคุณ
const TABLE_NAME = process.env.REACT_APP_TABLE_NAME; // ใส่ชื่อ Table ที่ต้องการดึงข้อมูล
const CUSTOMER_TABLE_NAME = process.env.REACT_APP_CUSTOMER_TABLE_NAME; // ใส่ชื่อ Table ของลูกค้า

const airtable = axios.create({
    baseURL: `https://api.airtable.com/v0/${BASE_ID}`,
    headers: {
      Authorization: `Bearer ${PERSONAL_ACCESS_TOKEN}`,
    },
  });




  export const fetchOrders = async () => {
    try {
        let allRecords = [];
        let offset;

        // ตั้งค่า Time Zone
        const timeZone = 'Asia/Bangkok'; // เช่น เวลาไทย

        // คำนวณวันเริ่มต้นของวันนี้และเมื่อวานใน Time Zone ที่ต้องการ
        const today = moment().tz(timeZone).startOf('day').format('YYYY-MM-DD');
        const yesterday = moment().tz(timeZone).subtract(1, 'day').startOf('day').format('YYYY-MM-DD');

        const formula = `AND({การจัดส่ง} = 'ร้านส่งเอง', OR(IS_SAME({กำหนดส่ง}, "${today}", "day"), IS_SAME({กำหนดส่ง}, "${yesterday}", "day")))`;

        do {
            const response = await airtable.get(`/${TABLE_NAME}`, {
                params: {
                    offset: offset,
                    pageSize: 100,
                    filterByFormula: formula
                },
            });

            allRecords = [...allRecords, ...response.data.records];
            offset = response.data.offset;

        } while (offset);

        return allRecords;

    } catch (error) {
        console.error('Error fetching orders:', error);
        return [];
    }
};




export const updateOrderStatus = async (orderId, newStatus, username) => {
    try {
        const fields = { 'คนส่งอัพเดทโดย': username };
        
        // ถ้า `newStatus` มีค่า ให้ใช้ค่านั้น; ถ้าไม่มี ให้ลบสถานะโดยการตั้งค่าเป็น `null`
        if (newStatus) {
            fields['สถานะ'] = newStatus;
        } else {
            fields['สถานะ'] = null; // ตั้งค่าเป็น null เพื่อลบสถานะ
        }

        const response = await airtable.patch(`/${TABLE_NAME}/${orderId}`, { fields });

        return response.data;
    } catch (error) {
        console.error('Error updating order status:', error);
        return null;
    }
};





